import { Injectable } from '@angular/core';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption, SimpleConfigBaseFilter } from 'gung-list';
import { map, Observable } from 'rxjs';
import { OpenOrderRowsTableComponent } from '../../components/open-order-rows-table/open-order-rows-table.component';
import { OpenOrderRow } from '../../models/order';
import { OrderService } from '../orders/order.service';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class OpenOrderRowsConfigService implements ConfigService<OpenOrderRow> {
  topFilter = true;

  constructor(protected orderService: OrderService) {}

  getItems(): Observable<OpenOrderRow[]> {
    return this.orderService.getOpenOrderRows().pipe(
      map(orders => {
        let openOrderRows = [];
        for (const order of orders) {
          let i = 1;
          for (const row of order.rows) {
            let rowToOrder: OpenOrderRow = {
              id: order.id,
              name: order.name,
              extra: order.extra,
              billingCustomerId: order.billingCustomerId,
              deliveryCustomerId: order.deliveryCustomerId,
              row: row,
              rowNumber: i
            };
            openOrderRows.push(rowToOrder);
            i++;
          }
        }
        return openOrderRows;
      })
    );
  }

  getFilters(): ConfigBaseFilter<OpenOrderRow>[] {
    return [new OrderRowStatusFilter(), new OrderRowOrderDateFilter(), new OrderRowDeliveryDateFilter()];
  }

  getSortOptions(): ListSortOption<OpenOrderRow>[] {
    // TODO: implement
    return [];
  }

  getBatchSizes(): number[] {
    return [24];
  }

  getLayouts(): ListLayout<OpenOrderRow>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => OpenOrderRowsTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Payment grid'
      }
    ];
  }

  getSearchTerms(item: OpenOrderRow): string[] {
    return [item.id];
  }

  getItemId(item: OpenOrderRow): string {
    return item.id;
  }

  getNothingFoundTranslateTag() {
    return 'NOTHING_FOUND';
  }
}

class OrderRowStatusFilter extends SimpleConfigBaseFilter<OpenOrderRow> {
  getName(): string {
    return 'ORDER_ROW_STATUS';
  }

  getOptionIds(item: OpenOrderRow): string[] {
    return [item.row?.extra?.gme?.status]
  }
  
  getOptionName(key: string): string {
    return key;
  }
}

export class OrderRowOrderDateFilter extends SimpleConfigBaseFilter<OpenOrderRow> {
  type = 'dateRangeFilter';

  getName(): string {
    return 'ORDER_DATE';
  }

  getOptionIds(item: OpenOrderRow): string[] {
    if (item?.extra?.gme?.orderDate) {
      return [format(new Date(item?.extra?.gme?.orderDate), 'yyMMdd')];
    }
    return [];
  }

  getOptionName(key: string): string {
    return key;
  }
}

export class OrderRowDeliveryDateFilter extends SimpleConfigBaseFilter<OpenOrderRow> {
  type = 'dateRangeFilter';

  getName(): string {
    return 'DELIVERY_DATE';
  }

  getOptionIds(item: OpenOrderRow): string[] {
    if (item?.extra?.gme?.deliveryDate) {
      return [format(new Date(item?.extra?.gme?.deliveryDate), 'yyMMdd')];
    }
    return [];
  }

  getOptionName(key: string): string {
    return key;
  }
}